<template>
    <div>
        <design-2021-apprentice-data-table
            class="yearbooks-overview"
            v-if="magazines.length"
            :fields="yeakbooksTableFields"
            :items="yearbooks">
            <template #options>
                <div class="management-options">
                    <b-form-select
                        class="deadline-type-select"
                        v-model="selected"
                        @change="deadlineChange">
                        <option
                            v-for="deadline in deadlines"
                            v-if="deadline.agenda_item"
                            :value="deadline.id">
                            {{ deadline.agenda_item.date }}
                        </option>
                        <option :value="0">{{ $t('magazine.exceptions') }}</option>
                        <option :value="-1">{{ $t('magazine.without_deadline') }}</option>
                        <option :value="-2">{{ $t('magazine.all_yearbooks') }}</option>
                    </b-form-select>

                    <b-button
                        class="btn btn-primary btn-download-list"
                        variant="primary"
                        :href="routes.baseUrl() + '/magazine/download' + type + '/' + selected">
                        {{ $t('common.download') }}
                    </b-button>

                    <b-button
                        class="btn btn-primary btn-yearbook-settings"
                        variant="primary"
                        @click="showYearbookSettings()">
                        <i class="btn-settings"></i>{{ $t('magazine.settings') }}
                    </b-button>
                </div>
            </template>

            <template #cell(ref)="row">
                <span class="page_size">
                    <!--                    todo: omzetten naar belongsto relaties admin accounts van het memories team.-->
                    <b-form-select
                        class="float-right"
                        v-model="row.item.ref"
                        @change="refChange($event, row)">
                        <option value="TD">TD</option>
                        <option value="TP">TP</option>
                        <option value="RdL">RdL</option>
                    </b-form-select>
                </span>
            </template>

            <template #cell(school_id)="data">
                <span class="page_size">
                    {{ data.value }}
                </span>
            </template>

            <template #cell(page_size)="row">
                <span class="page_size">
                    {{ row.item.size.title }}
                </span>
            </template>

            <template #cell(deadline)="row">
                <span
                    class="deadline"
                    v-if="row.item.customdeadline">
                    {{ row.item.customdeadline.fulldate }}
                </span>
            </template>

            <template #cell(pages)="row">
                <div class="pages">
                    <div
                        class="float-left"
                        style="width: 50px; height: 100%; text-align: center">
                        {{ row.item.num_pages }}
                    </div>
                    <div
                        class="float-left"
                        style="width: 10px; text-align: center">
                        |
                    </div>
                    <div
                        class="float-left"
                        style="width: 50px; height: 100%; text-align: center">
                        {{ row.item.approved_pages_count }}
                    </div>
                </div>
            </template>

            <template #cell(last_edited)="row">
                <span class="last_edited">
                    {{ row.item.last_edited.lastEdited }}
                </span>
            </template>

            <template #cell(status)="row">
                <span
                    class="status"
                    v-if="row.item.control_status">
                    {{ row.item.control_status }}
                </span>
            </template>
            <template #cell(control_status)="row">
                <b-button
                    class="btn-clean btn-check"
                    v-if="
                        row.item.control_status &&
                        ['Verwerkt', 'Afgekeurd', 'Akkoord', 'JPG verwerkt'].includes(row.item.control_status)
                    "
                    variant="inverse-primary"
                    @click="onCheck(row.item.id)"
                    title="Controleren">
                    <i class="fa fa-check fa-fw"></i>
                </b-button>
            </template>
            <template #cell(cjp_promotional)="data">
                <i
                    class="fas fa-check success"
                    v-if="data.item.cjp_promotional"></i>
            </template>
            <template #cell(send_to_press)="data">
                <b-form-checkbox
                    v-model="data.item.send_to_press"
                    :value="1"
                    :unchecked-value="0"
                    name="send_to_press"
                    switch
                    @change="toggleSendToPress($event, data.item.id)">
                </b-form-checkbox>
            </template>

            <template #cell(actions)="row">
                <b-button
                    class="btn-clean btn-select"
                    variant="inverse-primary"
                    @click="onSelect(row.item.school_id, row.item.id)"
                    :title="$t('common.open')">
                    <i class="fas fa-folder-open fa-fw"></i>
                </b-button>

                <b-button
                    class="btn-clean btn-select"
                    variant="inverse-primary"
                    :style="[row.item.comment ? 'color: orange' : '']"
                    title="Comment"
                    @click="openCommentModal(row.item)">
                    <i class="fas fa-comment fa-fw"></i>
                </b-button>
                <b-button
                    class="btn-clean btn-select"
                    variant="inverse-primary"
                    :title="$t('common.color')"
                    @click="openColorModal(row.item)">
                    <i class="fas fa-palette fa-fw"></i>
                </b-button>
                <b-button
                    class="btn-clean btn-select"
                    variant="inverse-primary"
                    :style="[row.item.todo ? 'color: orange' : '']"
                    title="Todo"
                    @click="openTodoModal(row.item)">
                    <i class="fas fa-ballot-check fa-fw"></i>
                </b-button>

                {{ row.item.todo ? row.item.todo.slice(0, 15) : '' }}
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="yearbooks-not-found"
            v-else>
            <div class="yearbook-type-select">
                <b-form-select
                    class="float-right"
                    v-model="selected"
                    @change="deadlineChange">
                    <option
                        v-for="deadline in deadlines"
                        v-if="deadline.agenda_item"
                        :value="deadline.id">
                        {{ deadline.agenda_item.date }}
                    </option>
                    <option :value="0">{{ $t('magazine.exceptions') }}</option>
                    <option :value="-1">{{ $t('magazine.without_deadline') }}</option>
                    <option :value="-2">{{ $t('magazine.all_yearbooks') }}</option>
                </b-form-select>

                <b-button
                    class="btn btn-primary btn-yearbook-settings"
                    variant="primary"
                    @click="showYearbookSettings()">
                    <i class="btn-settings"></i>{{ $t('common.settings') }}
                </b-button>
            </div>

            <div class="notice">
                <b-alert
                    variant="warning"
                    show
                    >{{ $t('magazine.no_products_found') }}</b-alert
                >
            </div>
        </div>
        <design-2021-magazine-yearbooks-settings-modal-component ref="yearbook-settings-modal">
        </design-2021-magazine-yearbooks-settings-modal-component>
        <design-2021-magazine-yearbooks-comment-modal-component
            ref="comment-modal"
            @update-admin-values="updateAdminValues($event)"></design-2021-magazine-yearbooks-comment-modal-component>
        <design-2021-magazine-yearbooks-todo-modal-component
            ref="todo-modal"
            @update-admin-values="updateAdminValues($event)"></design-2021-magazine-yearbooks-todo-modal-component>
        <design-2021-magazine-yearbooks-color-modal-component
            ref="color-modal"
            @update-admin-values="updateAdminValues($event)"></design-2021-magazine-yearbooks-color-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-yearbooks-component',
    props: ['yearbooksIn', 'deadlinesIn', 'deadlineIn', 'type'],
    data() {
        var selected = null;
        if (this.deadlineIn || this.deadlinesIn.length) {
            selected = this.deadlineIn ? this.deadlineIn : this.deadlinesIn[0].id;
        }
        return {
            selected: selected,
            deadlines: this.deadlinesIn,
            magazines: this.yearbooksIn,
            yeakbooksTableFields: [
                {
                    key: 'ref',
                    label: 'Ref',
                    sortable: true,
                },
                {
                    key: 'schoolmagazine_id',
                    label: 'ID',
                    sortable: true,
                },
                {
                    key: 'title',
                    label: this.$t('common.title'),
                    sortable: true,
                },
                {
                    key: 'deadline',
                    label: this.$t('common.deadline'),
                    sortable: true,
                },
                /*{
                        key: 'pages',
                        label: 'Pagina\'s | klaar',
                    },
                    {
                        key: 'last_edited',
                        label: 'Laatst bewerkt',
                    },*/
                {
                    key: 'version',
                    label: this.$t('magazine.format_type'),
                    sortable: true,
                },
                {
                    key: 'page_size',
                    label: this.$t('magazine.format'),
                    sortable: true,
                },
                {
                    key: 'printer',
                    label: this.$t('magazine.printer'),
                    sortable: true,
                },
                {
                    key: 'status',
                    label: this.$t('magazine.status'),
                    sortable: true,
                },
                {
                    key: 'control_status',
                    label: this.$t('magazine.check'),
                    sortable: true,
                },
                {
                    key: 'cjp_promotional',
                    label: 'CJP',
                    sortable: true,
                },
                {
                    key: 'send_to_press',
                    label: this.$t('magazine.to_printer'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            magazinesTableColumns: [
                'school_id',
                'title',
                'pages',
                'last_edited',
                'version',
                'page_size',
                'printer',
                'status',
                'actions',
            ],
            magazinesTableOptions: {
                headings: {
                    ref: 'Ref',
                    school_id: 'ID',
                    title: this.$t('common.title'),
                    pages: this.$t('magazine.pages_ready'),
                    last_edited: this.$t('magazine.last_edited'),
                    version: this.$t('magazine.format_type'),
                    page_size: this.$t('magazine.format'),
                    printer: this.$t('magazine.printer'),
                    status: 'Status',
                    actions: this.$t('common.actions'),
                },
            },
        };
    },
    computed: {
        yearbooks() {
            return this.magazines.map((magazine) => {
                if (magazine.status && magazine.status.length) {
                    magazine.control_status = magazine.status[0].status;
                }
                if (magazine.color) {
                    magazine._rowVariant = magazine.color;
                }
                magazine.deadline = magazine.customdeadline ? magazine.customdeadline.date_time : null;

                return magazine;
            });
        },
    },
    methods: {
        showYearbookSettings() {
            this.$refs['yearbook-settings-modal'].show();
        },
        deadlineChange() {
            window.location.href = this.routes.baseUrl() + '/magazine/' + this.type + '/' + this.selected;
        },
        onSelect(school_id, id) {
            window.open(this.routes.baseUrl() + '/magazine/open/' + school_id + '/' + id, '_blank');
        },
        onCheck(id) {
            window.location.href = this.routes.baseUrl() + '/magazine/' + id + '/check/' + this.selected;
        },
        refChange(value, row) {
            const data = {
                ref: value,
            };

            this.axios.post(this.routes.magazineSetRef(row.item.id), data).then(
                (response) => {
                    this.magazines = this.magazines.map((magazine) => {
                        if (magazine.id === row.item.id) {
                            magazine.ref = value;
                        }
                        return magazine;
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        reloadTable() {
            this.$refs.table.refresh();
        },
        openCommentModal(magazine) {
            this.$refs['comment-modal'].show(magazine);
        },
        openTodoModal(magazine) {
            this.$refs['todo-modal'].show(magazine);
        },
        openColorModal(magazine) {
            this.$refs['color-modal'].show(magazine);
        },
        updateAdminValues(data) {
            const id = data.id;
            let values = data.values;
            this.magazines = this.magazines.map((magazine) => {
                if (magazine.id !== id) {
                    return magazine;
                }
                values._rowVariant = values.color ? values.color : null;
                return { ...magazine, ...values };
            });
        },
        toggleSendToPress(state, magazineId) {
            let data = {
                magazine_id: magazineId,
                send_to_press: state,
            };

            this.axios.post(this.routes.magazineSendToPress(), data).then(
                (response) => {
                    this.magazines = this.magazines.map((magazine) => {
                        if (magazine.id === magazineId) {
                            magazine.send_to_press = state;
                        }
                        return magazine;
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.management-options {
    display: flex;
    flex-wrap: wrap;
    row-gap: map-get($grid-gutter-spacing, 'ten');
    align-items: center;
    justify-content: flex-end;
    column-gap: map-get($grid-gutter-spacing, 'eight');
    flex: 1;

    .btn {
        &:before {
            margin-right: 0;
        }
    }
}

.yearbooks-overview :deep table tbody td {
    white-space: nowrap;
}

.btn-yearbook-settings {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: map-get($grid-gutter-spacing, 'eight');
}

.yearbooks-overview :deep .apprentice-table-call-to-actions select {
    margin-bottom: 15px;
}

.yearbooks-not-found {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-content: flex-end;
}

.yearbook-type-select select {
    margin-right: 0;
    margin-bottom: 15px;
}

.yearbooks-overview :deep {
    .btn:has(i):not(.btn-yearbook-settings) {
        color: $primary;
        border: none;
    }
}

@media (min-width: 576px) {
    .yearbook-type-select select {
        width: auto;
    }

    .yearbooks-overview :deep .apprentice-table-call-to-actions select {
        margin-bottom: 0;
        margin-right: 15px;
        width: auto;
    }

    .deadline-type-select {
        width: 200px;
    }
}
</style>
